// Composant BANDE
import { h } from 'preact'
import { useLayoutEffect } from 'preact/hooks'
import { setAllToMaxHeight } from '../../js/modules/setAllToMaxHeight.js'

// Composant principal
export const RecoEquipements = ({ title, items, viewAllCategories, device }) => {
   useLayoutEffect(() => {
      if (device !== 'mobile') {
         setAllToMaxHeight('.js-reco-title')
      }
   }, [])

   return (
      <div class="reco-equipements bg-gray2 pt-3 pb-2 mb-2 mb-xl-3" data-testid="bande-reco-equipements">
         <div class="container-fluid">
            <div class="row">
               <div class="col-12">
                  <h2 class="mb-2 mb-xl-3 mw-100">{title}</h2>
               </div>
               <div class="col-12">
                  <div class="row slider-eqpt">
                     {items.map((item, index) => (
                        <Equipement {...item} index={index + 1} />
                     ))}
                  </div>
               </div>
               <div class="col-12 d-flex justify-content-center">
                  <a
                     class="o-link-arrow px-1 pt-2"
                     href={viewAllCategories.URL}
                     data-testid="view-all-equipement"
                     data-oevent-category={viewAllCategories.analytics.oeventCategory}
                     data-oevent-action={viewAllCategories.analytics.oeventAction}
                     data-oevent-label={viewAllCategories.analytics.oeventLabel}
                     data-oevent-other={viewAllCategories.analytics.oeventOther}
                  >
                     {viewAllCategories.label}
                  </a>
               </div>
            </div>
         </div>
      </div>
   )
}

// Element Equipement Personnalisé
const Equipement = (props) => {
   const { analytics, URL, badge, model, brand, DAS, priceLabel, price, realPrice, financing, offer, image, index } = props
   // BUGFIX========================
   // placer un virguler 2 caratères avant la fin dans financing
   if (financing !== '') {
      let positionEuro = financing.indexOf("€"); 
      var financingEuro = financing.slice(0, positionEuro - 3) + "," + financing.slice(positionEuro - 3);
   }
   // BUGFIX========================
   return (
      <div class="col-3">
         <a
            href={URL}
            class="item-recoEquipement"
            data-testid={`reco-equipements${index}`}
            data-pdb-zid={analytics.pdbZid}
            data-pdb-sc={analytics.pdbSc}
            data-pdb-idc={analytics.pdbIdc}
            data-pdb-vi={analytics.pdbVi}
            data-pdb-ta={analytics.pdbTa}
            data-adv-canal={analytics.advCanal}
            data-adv-cappingdata={analytics.advCappingdata}
            data-oevent-category={analytics.oeventCategory}
            data-oevent-action={analytics.oeventAction}
            data-oevent-label={analytics.oeventLabel}
            data-oevent-other={analytics.oeventOther}
         >
            <div class="inner">
               {badge !== '' ? <strong class="tag ob1-tag ob1-tag-primary">{badge}</strong> : ''}

               <h3 class="title js-reco-title">
                  <strong>{brand}</strong> <span>{model}</span>
               </h3>

               <div class="visuel">
                  <img src={image} aria-hidden="true" class="mw-100" loading="lazy" />
               </div>

               <div class="das">
                  {DAS.map((item) => {
                     return (
                        <div>
                           <span>{item.label}&nbsp;:</span> <strong dangerouslySetInnerHTML={{ __html: item.value.replaceAll(' ', '&nbsp;') }}></strong>
                        </div>
                     )
                  })}
               </div>

               <div class="ob1-price">
                  <span class="sr-only">
                     {priceLabel} {price} au lieu de {realPrice}
                  </span>
                  <p aria-hidden="true">
                     <span class="ob1-price-from">{priceLabel}</span>
                     <span class="ob1-price-amount">{price}</span>
                     <span class="ob1-price-without-promo">{realPrice}</span>
                  </p>
               </div>

               {financingEuro !== '' ? <span class="ob1-capsule ob1-capsule-context">{financingEuro}</span> : ''}
            </div>
            {offer !== '' ? <div class="offer">{offer}</div> : ''}
         </a>
      </div>
   )
}
